<template>
  <div class="px-1 py-5 md:px-4">
    <submission-spinner v-if="showSpinner"></submission-spinner>
    <div v-else class="">
      <TopicReply
        v-if="message.replyingTo"
        :replying-to="message.replyingTo"
        v-on:scroll-to-message="onScrollToMessage"
      ></TopicReply>
      <div class="flex flex-row">
        <div class="hidden md:block">
          <avatar :user-display="message.userDisplay" v-if="false"></avatar>
          <div class="flex items-center" v-if="isAdmin">
            <button
              @click="remove"
              class=" p-1 rounded-full  relative mt-2 mx-auto focus:outline-none"
            >
              <svg
                viewBox="0 0 20 20"
                fill="currentColor"
                class="text-darkBlue fill-current w-6 h-6 hover:text-red"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
          </div>
        </div>
        <topic-message-display
          :message="message"
          v-on:replying-to="handleReplyingTo"
        ></topic-message-display>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "./Avatar";
import SubmissionSpinner from "./SubmissionSpinner";
import TopicMessageDisplay from "./TopicMessageDisplay";
import { mapGetters } from "vuex";
import TopicReply from "./topic/TopicReply";

export default {
  name: "TopicMessage",
  components: {
    TopicReply,
    SubmissionSpinner,
    Avatar,
    TopicMessageDisplay
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      modal: false
    };
  },
  methods: {
    remove() {
      this.$emit("remove-message", this.message.id);
      this.modal = false;
    },
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
    handleReplyingTo(message) {
      console.log("replying to");
      console.log(message);
      this.$emit("replying-to", message);
    },
    onScrollToMessage(message) {
      console.log("scrolling to" + message.id);
      console.log(message);
      this.$emit("scroll-to-message", message);
    }
  },
  computed: {
    ...mapGetters(["isAdmin", "deletedMessageID"]),
    showSpinner() {
      if (this.deletedMessageID === this.message.id) {
        return true;
      }
      return false;
    },
    postDate() {
      if (this.message.timestamp) {
        return this.message.timestamp.toDate().toLocaleString();
      }
      return "";
    },
    initial() {
      return this.message.userDisplay.charAt(0);
    },
    imageAttachments() {
      let images = [];
      if (this.message.attachments) {
        images = this.message.attachments.filter(at =>
          at.key.includes("images/")
        );
      }
      return images;
    },
    fileAttachments() {
      let files = [];
      if (this.message.attachments) {
        files = this.message.attachments.filter(
          at => at.key.includes("images/") === false
        );
      }
      return files;
    }
  }
};
</script>

<style scoped></style>
